//#region IMPORT
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
/** Services Import */
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
import useCompanyCustDep from '../../../../hooks/useCompanyCustDep';
/** Components */
import { SAM_BASIC } from './index';
import {
  ReadSamInitialTabFromSession,
  ScheduleClearSamInitialTabSession,
} from './samInitialTabSession';
import { setPageTab } from '../../../../Services/Manual/adminManualPdf';

/** `navigate(..., { state })`로 전달 — URL 쿼리 없이 초기 탭 지정 */
const SAM_INITIAL_TAB_STATE_KEY = 'samInitialTab';

function ReadSamInitialTabFromState(state) {
  const raw = state?.[SAM_INITIAL_TAB_STATE_KEY];
  return raw === 0 || raw === 1 ? raw : null;
}
//#endregion

function SAM_BASICF() {
  //#region 변수
  const navigate = useNavigate();
  const routerLocation = useLocation();
  const dispatch = useDispatch();
  const { userInfo, custInfo, lanInfo } = useSelector(
    (state) => state.BaseInfo
  );
  const searchInfo = useSelector((state) => state.SearchInfo);

  /** sessionStorage 우선(history.state 가 라우팅 중 유실되는 경우 대비) → 그다음 location.state */
  const [value, setValue] = React.useState(() => {
    const fromSession = ReadSamInitialTabFromSession();
    if (fromSession !== null) return fromSession;
    const t = ReadSamInitialTabFromState(routerLocation.state);
    return t !== null ? t : 0;
  });
  const [custCd, setCustCd] = useState('');

  // 회사/거래처 선택 상태 관리 및 필수 여부 검증을 위한 Hook
  const {
    handleCoChange,
    handleCustChange,
    handleDepChange,
    validateSelection,
  } = useCompanyCustDep({
    requireCompany: true,
    requireCust: true,
    requireDep: false,
    autoFetchDep: true,
    autoFetchDepDefaultAll: false,
  });

  const [filterClick1, setFilterClick1] = useState(false); // 1번탭 버튼 이벤트
  const [searchClick1, setSearchClick1] = useState(false);
  const [addClick1, setAddClick1] = useState(false);
  const [saveClick1, setSaveClick1] = useState(false);
  const [deleteClick1, setDeleteClick1] = useState(false);
  const [printClick1, setPrintClick1] = useState(false);
  const [copyClick1, setCopyClick1] = useState(false);
  const [listClick1, setListClick1] = useState(false);

  const [filterClick2, setFilterClick2] = useState(false); // 2번탭 버튼 이벤트
  const [searchClick2, setSearchClick2] = useState(false);
  const [addClick2, setAddClick2] = useState(false);
  const [saveClick2, setSaveClick2] = useState(false);
  const [deleteClick2, setDeleteClick2] = useState(false);
  const [printClick2, setPrintClick2] = useState(false);
  const [copyClick2, setCopyClick2] = useState(false);
  const [listClick2, setListClick2] = useState(false);
  //#endregion

  const executed = useRef(false);
  /** state.samInitialTab 재적용은 “새 네비게이션”(location.key 변경)일 때만 — 그 외에는 사용자 탭 전환 덮어쓰기 방지 */
  const lastHandledLocationKeyRef = useRef(null);

  /** Strict Mode 이중 마운트에서도 두 번째 init 이 세션을 읽을 수 있게, 지연 후 세션 제거 */
  useEffect(() => {
    const tid = ScheduleClearSamInitialTabSession();
    return () => clearTimeout(tid);
  }, []);

  /** 현재 탭을 매뉴얼 레지스트리에 동기화 */
  useEffect(() => {
    setPageTab('SafetyWorkManagement', value);
  }, [value]);

  /**
   * `navigate('/SafetyWorkManagement', { state: { samInitialTab: 0|1 } })`
   * state 는 지우지 않음(Strict Mode·재마운트 시에도 허가 탭 유지). 초기 탭은 위 useState 가 담당.
   */
  useEffect(() => {
    if (!searchInfo.custCd) return;

    const t = ReadSamInitialTabFromState(routerLocation.state);

    if (!executed.current) {
      executed.current = true;
      if (t !== null) {
        setValue(t);
      }
      const tabToSearch = t !== null ? t : value;
      if (tabToSearch === 0) setSearchClick1(true);
      else setSearchClick2(true);
      lastHandledLocationKeyRef.current = routerLocation.key;
      return;
    }

    if (t === null) return;
    if (routerLocation.key === lastHandledLocationKeyRef.current) return;
    lastHandledLocationKeyRef.current = routerLocation.key;
    setValue(t);
    if (t === 0) setSearchClick1(true);
    else setSearchClick2(true);
  }, [searchInfo.custCd, routerLocation.state, routerLocation.key, value, dispatch]);

  // 탭 클릭 이벤트 — 해당 탭 자동 조회
  const HandleChange = (event, newValue) => {
    if (newValue === 0) setSearchClick1(true);
    else if (newValue === 1) setSearchClick2(true);

    setValue(newValue);
    setPageTab('SafetyWorkManagement', newValue);
  };

  //#endregion

  return (
    <div className="wrap">
      <SAM_BASIC
        navigate={navigate}
        userInfo={userInfo}
        lanInfo={lanInfo}
        searchInfo={searchInfo}
        value={value}
        filterClick1={filterClick1}
        setFilterClick1={setFilterClick1}
        searchClick1={searchClick1}
        setSearchClick1={setSearchClick1}
        addClick1={addClick1}
        setAddClick1={setAddClick1}
        saveClick1={saveClick1}
        setSaveClick1={setSaveClick1}
        deleteClick1={deleteClick1}
        setDeleteClick1={setDeleteClick1}
        printClick1={printClick1}
        setPrintClick1={setPrintClick1}
        copyClick1={copyClick1}
        setCopyClick1={setCopyClick1}
        listClick1={listClick1}
        setListClick1={setListClick1}
        filterClick2={filterClick2}
        setFilterClick2={setFilterClick2}
        searchClick2={searchClick2}
        setSearchClick2={setSearchClick2}
        addClick2={addClick2}
        setAddClick2={setAddClick2}
        saveClick2={saveClick2}
        setSaveClick2={setSaveClick2}
        deleteClick2={deleteClick2}
        setDeleteClick2={setDeleteClick2}
        printClick2={printClick2}
        setPrintClick2={setPrintClick2}
        copyClick2={copyClick2}
        setCopyClick2={setCopyClick2}
        listClick2={listClick2}
        setListClick2={setListClick2}
        custCd={custCd}
        setCustCd={setCustCd}
        // getDepLastName={getDepLastName}
        dispatch={dispatch}
        showSnackbar={showSnackbar}
        // 회사, 사업장 관련 props
        handleCoChange={handleCoChange}
        handleCustChange={handleCustChange}
        handleDepChange={handleDepChange}
        validateSelection={validateSelection}
        // 함수
        HandleChange={HandleChange}
      />
    </div>
  );
}

export default SAM_BASICF;
